var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prohibit-alternative-msg text-danger text-center"},[_c('span',{staticClass:"ml-2"},[_vm._v("*")]),_c('span',{staticClass:"font-size-xs mx-1 text-left"},[_vm._v(_vm._s(_vm.$t('itemProhibitAlternativeMsg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }